export default [
  {
    text: "首页",
    path: "/home",
    icon: "home"
  },
  {
    text: "权限管理",
    icon: "folder",
      items: [
          {
            text: "用户",
            path: "/user",
          },
          {
            text: "角色",
            path: "/role",
          }
      ]
  },
  {
    text: "客户管理",
    icon: "folder",
    items: [
      {
        text: "客户",
        path: "/CustomerPage"
      },
      {
        text: "线索",
        path: "/CluePage"
      }
    ]
  },
  //   {
  //   text: "消息推送",
  //   icon: "folder",
  //   items: [
  //     {
  //       text: "模板消息",
  //       path: "/wechatTags"
  //     },
  //     {
  //       text: "发送消息",
  //       path: "/sendMessage"
  //     },
  //     {
  //       text: "定时任务",
  //       path: "/tasksMessage"
  //     }
  //   ]
  // },
  {
    text: "订阅产品",
    icon: "folder",
    items: [
      {
        text: "营销计划",
        path: "/marketingList"
      },
      {
        text: "内容管理",
        path: "/contentPage"
      },
      {
        text: "生日推送",
        path: "/marketingBirthday"
      },
      {
        text: "营销活动",
        path: "/markeingActivity"
      }
    ]
  },
  {
    text: "配置管理",
    icon: "folder",
    items: [
      {
        text: "公众号管理",
        path: "/addWechat"
      }
    ]
  }
  ];
